import { isServerRendering } from '../_util/dom';
// get element's position relative to root element
function getElementPosition(element, root) {
    if (!root || !element || isServerRendering) {
        return { left: 0, width: 0, height: 0, top: 0 };
    }
    // safari and chrome
    var bodyScroll = function (direction) { return document.documentElement[direction] || document.body[direction]; };
    var pageScrollTop = root === document.body ? bodyScroll('scrollTop') : root.scrollTop;
    var pageScrollLeft = root === document.body ? bodyScroll('scrollLeft') : root.scrollLeft;
    var _a = element.getBoundingClientRect(), left = _a.left, top = _a.top, width = _a.width, height = _a.height;
    // custom container
    var rootLeft = root === document.body ? 0 : root.getBoundingClientRect().left;
    var rootTop = root === document.body ? 0 : root.getBoundingClientRect().top;
    var pTop = top + pageScrollTop - rootTop;
    var pLeft = left + pageScrollLeft - rootLeft;
    return {
        left: pLeft,
        top: pTop,
        width: width,
        height: height,
    };
}
var getInsideValue = function (min, max, value) {
    if (value < min) {
        return min;
    }
    if (value > max) {
        return max;
    }
    return value;
};
export default (function (props, content, child, mountContainer) {
    var autoAlignPopupWidth = props.autoAlignPopupWidth, autoAlignPopupMinWidth = props.autoAlignPopupMinWidth;
    if (!child || !content) {
        return {};
    }
    var style = {};
    var _a = getElementPosition(child, mountContainer), left = _a.left, top = _a.top, width = _a.width, height = _a.height;
    var popupAlign = props.popupAlign;
    var alignLeft = popupAlign.left || 0;
    var alignRight = popupAlign.right || 0;
    var alignTop = popupAlign.top || 0;
    var alignBottom = popupAlign.bottom || 0;
    if (autoAlignPopupWidth) {
        content.style.width = child.offsetWidth + "px";
    }
    if (autoAlignPopupMinWidth) {
        content.style.minWidth = child.offsetWidth + "px";
    }
    var childRect = child.getBoundingClientRect();
    var realPosition = props.position;
    var arrowStyle = {};
    var autoPosition = function (direction) {
        var windowHeight = window.innerHeight;
        var windowWidth = window.innerWidth;
        // 视口左侧/顶部到 popupcontainer 的距离
        var boundnary = {
            left: left - childRect.left,
            top: top - childRect.top,
        };
        var _a = style.top, styleTop = _a === void 0 ? 0 : _a, _b = style.left, styleLeft = _b === void 0 ? 0 : _b;
        // 水平方向微调
        if (direction === 'top' || direction === 'bottom') {
            if (boundnary.left > styleLeft && childRect.right > 12) {
                // 左边被遮挡
                style.left = Math.max(boundnary.left, left - content.clientWidth);
                style.left = Math.max(style.left, left - content.clientWidth + 24);
            }
            else if (styleLeft - boundnary.left + content.clientWidth > windowWidth &&
                windowWidth - childRect.left > 12) {
                // 右侧被遮挡，右侧贴边。如果child在可视区内的宽度小于12，不进行位置调整
                style.left = Math.max(boundnary.left, boundnary.left + windowWidth - content.clientWidth);
                style.left = Math.max(style.left, left - content.clientWidth + 24);
            }
            arrowStyle = {
                left: left - Number(style.left) + width / 2,
            };
        }
        // 垂直方向微调
        if (direction === 'left' || direction === 'right') {
            if (boundnary.top > styleTop && childRect.bottom > 12) {
                // 上面
                style.top = boundnary.top;
                style.top = Math.max(style.top, top - content.clientHeight + 24);
            }
            else if (styleTop - boundnary.top + content.clientHeight > windowHeight &&
                windowHeight - childRect.top > 12) {
                // 向下微调位置，如果child在可视区内的高度小于12，不进行位置调整
                style.top = Math.max(boundnary.top, boundnary.top + windowHeight - content.clientHeight);
                style.top = Math.max(style.top, top - content.clientHeight + 24);
            }
            arrowStyle = {
                top: top - Number(style.top) + height / 2,
            };
        }
        if (direction === 'top' && boundnary.top > styleTop) {
            // 上面被遮挡
            if (childRect.top < windowHeight - childRect.bottom) {
                // 放到下面
                style.top = Math.min(top + height + (alignTop || 0), boundnary.top + windowHeight - content.clientHeight);
                return true;
            }
            // 贴顶部边界
            style.top = boundnary.top;
        }
        if (direction === 'bottom' && styleTop - boundnary.top + content.clientHeight > windowHeight) {
            // 下部分被遮挡
            if (windowHeight - childRect.bottom < childRect.top) {
                // 放到上面
                style.top = Math.max(top - content.clientHeight - (alignBottom || 0), boundnary.top);
                return true;
            }
            // 贴底边界
            style.top = boundnary.top + windowHeight - content.clientHeight;
        }
        if (direction === 'left' && boundnary.left > styleLeft) {
            // 左边被遮挡
            if (childRect.left < windowWidth - childRect.right) {
                // 放到右边
                style.left = Math.min(width + left + alignRight, boundnary.left + windowWidth - content.clientWidth);
                return true;
            }
            style.left = boundnary.left;
        }
        if (direction === 'right' && styleLeft - boundnary.left + content.clientWidth > windowWidth) {
            // 右边被遮挡
            if (windowWidth - childRect.right < childRect.left) {
                // 放到左边
                style.left = Math.max(left - content.clientWidth - alignLeft, boundnary.left);
                return true;
            }
            // 贴左边界
            style.left = boundnary.left + windowWidth - content.clientWidth;
        }
    };
    switch (props.position) {
        case 'top':
            style.top = top - content.clientHeight - alignTop;
            style.left = left + width / 2 - content.clientWidth / 2;
            autoPosition('top') && (realPosition = 'bottom');
            break;
        case 'tl':
            style.top = top - content.clientHeight - alignTop;
            style.left = left;
            autoPosition('top') && (realPosition = 'bl');
            var arrowLeft = left - Number(style.left) + Math.min(width / 2, 50);
            arrowStyle.left = getInsideValue(12, content.clientWidth - 12, arrowLeft);
            break;
        case 'tr':
            style.top = -content.clientHeight + top - alignTop;
            style.left = left + width - content.clientWidth;
            autoPosition('top') && (realPosition = 'br');
            arrowLeft = left - Number(style.left) + Math.max(width / 2, width - 50);
            arrowStyle.left = getInsideValue(12, content.clientWidth - 12, arrowLeft);
            break;
        case 'bottom':
            style.top = height + top + alignBottom;
            style.left = left + width / 2 - content.clientWidth / 2;
            autoPosition('bottom') && (realPosition = 'top');
            break;
        case 'bl':
            style.top = height + top + alignBottom;
            style.left = left;
            autoPosition('bottom') && (realPosition = 'tl');
            arrowLeft = left - Number(style.left) + Math.min(width / 2, 50);
            arrowStyle.left = getInsideValue(12, content.clientWidth - 12, arrowLeft);
            break;
        case 'br':
            style.top = height + top + alignBottom;
            style.left = left + width - content.clientWidth;
            autoPosition('bottom') && (realPosition = 'tr');
            arrowLeft = left - Number(style.left) + Math.max(width / 2, width - 50);
            arrowStyle.left = getInsideValue(12, content.clientWidth - 12, arrowLeft);
            break;
        case 'left':
            style.top = top + height / 2 - content.clientHeight / 2;
            style.left = left - content.clientWidth - alignLeft;
            autoPosition('left') && (realPosition = 'right');
            break;
        case 'lt':
            style.top = top;
            style.left = left - content.clientWidth - alignLeft;
            autoPosition('left') && (realPosition = 'rt');
            var arrowTop = top - Number(style.top) + Math.min(height / 2, 50);
            arrowStyle.top = getInsideValue(12, content.clientHeight - 12, arrowTop);
            break;
        case 'lb':
            style.top = top + height - content.clientHeight;
            style.left = left - content.clientWidth - alignLeft;
            autoPosition('left') && (realPosition = 'rb');
            arrowTop = top - Number(style.top) + Math.max(height / 2, height - 50);
            arrowStyle.top = getInsideValue(12, content.clientHeight - 12, arrowTop);
            break;
        case 'right':
            style.top = top + height / 2 - content.clientHeight / 2;
            style.left = width + left + alignRight;
            autoPosition('right') && (realPosition = 'left');
            break;
        case 'rt':
            style.top = top;
            style.left = width + left + alignRight;
            autoPosition('right') && (realPosition = 'lt');
            arrowTop = top - Number(style.top) + Math.min(height / 2, 50);
            arrowStyle.top = getInsideValue(12, content.clientHeight - 12, arrowTop);
            break;
        case 'rb':
            style.top = top + height - content.clientHeight;
            style.left = width + left + alignRight;
            autoPosition('right') && (realPosition = 'lb');
            arrowTop = top - Number(style.top) + Math.max(height / 2, height - 50);
            arrowStyle.top = getInsideValue(12, content.clientHeight - 12, arrowTop);
            break;
        default:
            break;
    }
    return {
        style: style,
        arrowStyle: arrowStyle,
        realPosition: realPosition,
    };
});
